import React from 'react';
import { Box, Chip, makeStyles } from '@material-ui/core';
import { AttachFile as FileIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  fileContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  fileChip: {
    maxWidth: 200,
    color: 'black',
    border: '1px solid white',
    backgroundColor: 'white',
  },
  imagePreview: {
    maxWidth: 200,
    maxHeight: 150,
    borderRadius: 8,
    marginTop: theme.spacing(1),
    cursor: 'pointer',
  },
}));

interface FilePreviewProps {
  files: File[];
}

export const FilePreview: React.FC<FilePreviewProps> = ({ files }) => {
  const classes = useStyles();

  const isImage = (file: File) => file.type.startsWith('image/');

  const handleImageClick = (file: File) => {
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
  };

  return (
    <Box className={classes.fileContainer}>
      {files.map((file, index) => (
        <Box key={index}>
          {isImage(file) ? (
            <img
              src={URL.createObjectURL(file)}
              alt={file.name}
              className={classes.imagePreview}
              onClick={() => handleImageClick(file)}
            />
          ) : (
            <Chip
              icon={<FileIcon />}
              label={file.name}
              size="small"
              className={classes.fileChip}
              variant="outlined"
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
